import { useClearFilter, useGetMainFilterApplied, useSetMainFilter } from '../publicCatalogFiltersHooks';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISearchInput from 'UIComponents/input/UISearchInput';
import debounce from 'react-utils/debounce';
import styled, { mediaQuery, css } from 'academy-common-lib/utils/Styling';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import { useEffect, useRef } from 'react';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const DEBOUNCE_DELAY = 800;
const StyledInput = styled(UISearchInput).withConfig({
  displayName: "PublicCatalogSearchInput__StyledInput",
  componentId: "sc-1d8xrzx-0"
})(["", ""], mediaQuery('notMobile', css(["input{padding:10px 20px;height:60px;}[data-icon-name='search']{margin-top:20px;}[data-icon-name='remove']{margin-top:10px;}"])));
const PublicCatalogSearchInput = () => {
  const [searchParams] = useSearchParams();
  const setMainFilter = useSetMainFilter();
  const clearFilter = useClearFilter();
  const searchInputRef = useRef(null);
  const mainFilterApplied = useGetMainFilterApplied();
  useEffect(() => {
    // Clear search input if search param is removed from URL (eg. if another primary filter is applied)
    if (!searchParams.search && searchInputRef.current) {
      searchInputRef.current.value = '';
    }
  }, [searchParams.search]);
  const debouncedSetMainFilter = debounce(setMainFilter, DEBOUNCE_DELAY);
  const handleSearchInputChange = searchValue => {
    // only clear the filter if the search filter is applied
    if (searchValue === '' && searchParams.search) {
      clearFilter('search');
      debouncedSetMainFilter.reset();
      return;
    }
    if (searchValue === '' && !searchParams.search) {
      return;
    }
    debouncedSetMainFilter('search', searchValue);
  };
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": I18n.text('academyPublic.catalogPage.filters.searchInputLabel'),
      children: /*#__PURE__*/_jsx(StyledInput, {
        defaultValue: mainFilterApplied === 'search' ? searchParams.search : '',
        inputRef: searchInputRef,
        onChange: event => handleSearchInputChange(event.target.value)
      })
    })
  });
};
export default PublicCatalogSearchInput;